import { Box, Button, Card } from "@mui/material";
import { Add } from "@mui/icons-material";
import { H5 } from "components/Typography";
import SearchInput from "components/input-fields/SearchInput";
import CategoryTable from "page-sections/Business-category/CategoryTable";
import FlexBox from "components/flexbox/FlexBox";
import { useState, useEffect } from "react";
import AddCategoryModal from "page-sections/Business-category/AddCategoryModel";
import { usePageTitle } from "contexts/PageTitleContext";

const BusinessCategory = () => {
  const [openModal, setOpenModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [editData, setEditData] = useState(null);
  const [refreshTable, setRefreshTable] = useState(0);
  const { setPageTitle } = usePageTitle();
  useEffect(() => {
    setPageTitle('Business Category Management');
}, [setPageTitle]);

  const handleModalClose = (shouldRefresh) => {
    setOpenModal(false);
    setEditData(null);
    if (shouldRefresh) {
      setRefreshTable(prev => prev + 1);
    }
  };

  return (
    <Box pt={2} pb={4}>
      <Card sx={{ padding: 3 }}>
        <FlexBox justifyContent="space-between" alignItems="center" mb={3}>
          <H5>Business Categories</H5>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => {
              setEditData(null);
              setOpenModal(true);
            }}
          >
            Add Category
          </Button>
        </FlexBox>

        <SearchInput
          placeholder="Search Categories..."
          onChange={(e) => setSearchQuery(e.target.value)}
        />

        <CategoryTable 
          searchQuery={searchQuery}
          refreshTrigger={refreshTable}
          onEdit={(category) => {
            setEditData(category);
            setOpenModal(true);
          }}
        />
      </Card>

      <AddCategoryModal
        open={openModal}
        onClose={handleModalClose}
        edit={Boolean(editData)}
        data={editData}
      />
    </Box>
  );
};

export default BusinessCategory;